import React from 'react'
import { LogoColor, LogoColorType } from 'types/types'
import { BvnkLogo } from './BvnkLogo'

interface LogoProps {
  logoColor?: LogoColorType
}

export const Logo = ({ logoColor = LogoColor.LIGHT }: LogoProps) => {
  return <BvnkLogo color={logoColor} />
}
